<template>
  <div class="btn-close position-absolute d-flex justify-content-end" :class="getClasses()" @click="emit">
    <img class="close-img" :src="require(`@/assets/icons/close.png`)" width="25">
  </div>
</template>

<script>
export default {
  name: 'ButtonClose',
  props: {
    groupIndex: {
      type: Number,
      default: () => null
    },
    index: {
      type: Number,
      default: () => null
    },
    unclickable: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    emit() {
      const { groupIndex, index, unclickable } = this
      !unclickable && this.$emit('event', { groupIndex, index})
    },
    getClasses() {
      const { unclickable } = this
      const classes = []
      unclickable && classes.push('unclickable')
      return classes.join(' ')
    }
  }
}
</script>
